import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, message, Row, Spin } from 'antd';
import MessageConfirmModal from '../messageModal/MessageConfirmModal';
import InputComponent from '../input/InputComponent';
import HeaderCreateNewsComponent from '../header/HeaderCreateNewsComponent';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PRODUCTS_KNOWLEDGE_URL } from '../../api/URLs';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import SelectComponent from '../select/SelectComponent';
import DragUploadComponent from '../upload/DragUploadComponent';
import OSSUploadWrapper from '../upload/OSSUploadWrapper';
import InputNumberComponent from '../input/InputNumberComponent';
import TechnicalDragViewMobileComponent from '../newsManagemet/TechnicalDragViewMobileComponent';
import { formatDateSecondary } from '../../utils/dateFormatUtils';

function ProductKnowledgeUpload() {
  const { newStep } = useParams();
  const { t } = useTranslation();
  let condeLang = 'cn';
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let id = queryParams.get('productKnowledgeId') || queryParams.get('id');
  const messageModalRef = useRef('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const dragViewMobileComponentRef = useRef('');
  const [dataObject, setDataObject] = useState({
    title: '',
    subtitle: '',
    // category: '产品知识',
    readingTime: '',
    publishedAt: '',
    expiryAt: '',
    status: false,
    isActive: true,
  });
  const [picUrl, setpicUrl] = useState([]);

  const [datalocalize, setDatalocalize] = useState();

  const checktextByLang = (dataCode) => {
    let text = dataCode && dataCode[condeLang] && dataCode[condeLang].title ? dataCode[condeLang].title : '';
    const languages = dataCode ? Object.keys(dataCode) : [];
    if (!text) {
      for (let lang of languages) {
        if (dataCode && dataCode[lang] && dataCode[lang].title) {
          text = dataCode[lang].title;
          break;
        }
      }
    }
    return text;
  };

  const checktextByLangSub = (dataCode) => {
    let text = dataCode && dataCode[condeLang] && dataCode[condeLang].subtitle ? dataCode[condeLang].subtitle : '';
    const languages = dataCode ? Object.keys(dataCode) : [];
    if (!text) {
      for (let lang of languages) {
        if (dataCode && dataCode[lang] && dataCode[lang].subtitle) {
          text = dataCode[lang].subtitle;
          break;
        }
      }
    }
    return text;
  };

  const addNewValue = async (data) => {
    const formattedData = {
      ...data,
      // productKnowledgeId: data?.productKnowledgeId || data?.id || data?._id || id,
    };
    setDataObject({
      ...data,
      // productKnowledgeId: formattedData.productKnowledgeId,
      title: checktextByLang(data.localize),
      subtitle: checktextByLangSub(data.localize),
      expiryAt: data?.expiryAt || '',
      publishedAt: data?.publishedAt || '',
      // category: data.category || '产品知识',
      readingTime: data?.readingTime,
      status: data?.status,
      isActive: data?.isActive !== undefined ? data.isActive : true,
    });
    setpicUrl(
      data.coverimage
        ? [
            {
              uid: '1',
              name: (data.coverimage && data.coverimage.fileName) || '',
              status: 'done',
              size: (data.coverimage && data.coverimage.size) || '',
              url: (data.coverimage && data.coverimage.url) || data.coverimage || '',
            },
          ]
        : []
    );
    formattedData && setDatalocalize(formattedData);
  };

  const [isCanSubmit, setIsCanSubmit] = useState(true);
  const getDetailById = async () => {
    try {
      setLoading(true);
      await getDataRequest(`${PRODUCTS_KNOWLEDGE_URL}/${id}`)
        .then((res) => {
          if (res.status === 200) {
            addNewValue(res.data);
          } else {
            setIsCanSubmit(false);
          }
          setLoading(false);
        })
        .catch((err) => {
          setIsCanSubmit(false);
          console.log(err);
          setLoading(false);
        });
    } catch (error) {
      setIsCanSubmit(false);
      setLoading(false);
      message.error('Server Error!');
    }
  };

  useEffect(() => {
    if (id) {
      getDetailById();
    }
  }, [newStep, id]);

  const checkError = () => {
    if (!dataObject.title || !dataObject.subtitle || !dataObject.readingTime) {
      return true;
    }
    return false;
  };

  const insertParams = () => {
    return {
      coverimage:
        picUrl && picUrl.length > 0
          ? {
              url: picUrl[0].url || '',
              size: picUrl[0].size || '',
              fileName: picUrl[0].name || '',
            }
          : '',
      title: dataObject.title,
      subtitle: dataObject.subtitle,
      expiryAt: formatDateSecondary(new Date()),
      publishedAt: formatDateSecondary(new Date()),
      // category: dataObject.category,
      readingTime: dataObject?.readingTime,
      // isActive: dataObject?.isActive !== undefined ? dataObject.isActive : true,
    };
  };

  const UpdatedParams = () => {
    return {
      coverimage:
        picUrl && picUrl.length > 0
          ? {
              url: picUrl[0].url || '',
              size: picUrl[0].size || '',
              fileName: picUrl[0].name || '',
            }
          : '',
      title: dataObject.title,
      subtitle: dataObject.subtitle,
      expiryAt: formatDateSecondary(new Date()),
      publishedAt: formatDateSecondary(new Date()),
      // category: dataObject.category,
      readingTime: dataObject?.readingTime,
      status: dataObject?.status,
      isActive: dataObject?.isActive !== undefined ? dataObject.isActive : true,
    };
  };

  const handleSubmitNext = async () => {
    setIsSubmit(true);
    if (checkError()) {
      return false;
    }
    setLoading(true);
    const payload = insertParams();
    try {
      const res = await postDataRequest(PRODUCTS_KNOWLEDGE_URL, payload);
      if (res?.status === 200) {
        let createdId = res.data?.productKnowledgeId || res.data?.id || res.data?._id || '';
        navigate(`/products-knowledge/upload/2?productKnowledgeId=${createdId}`);
      } else {
        messageModalRef.current.showWarningConfirmsAutoClose(
          res.data?.message || res.message || t('An error occurred.'),
          () => {},
          '',
          true
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      messageModalRef.current.showWarningConfirmsAutoClose(
        err?.response?.data?.message || err?.message || 'Server Error!',
        () => {},
        '',
        true
      );
    } finally {
      setLoading(false);
      setIsSubmit(false);
    }
  };

  const handleUpdateNext = async () => {
    setIsSubmit(true);
    if (checkError()) {
      return false;
    }
    setLoading(true);
    const payload = UpdatedParams();
    try {
      const res = await putDataRequest(`${PRODUCTS_KNOWLEDGE_URL}/${id}`, payload);
      if (res?.status === 200) {
        navigate(`/products-knowledge/upload/2?productKnowledgeId=${id}`);
      } else {
        messageModalRef.current.showWarningConfirmsAutoClose(
          res.data?.message || res.message || t('An error occurred.'),
          () => {},
          '',
          true
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      messageModalRef.current.showWarningConfirmsAutoClose(
        err?.response?.data?.message || err?.message || 'Server Error!',
        () => {},
        '',
        true
      );
    } finally {
      setLoading(false);
      setIsSubmit(false);
    }
  };

  const handleUpdate = async () => {
    dragViewMobileComponentRef.current?.handleSubmitContent();
  };

  let steps = [
    {
      title: t('Basic information settings'),
      status: newStep - 0 > 1 ? 'done' : 'processing',
      stepCount: 1,
    },
    {
      title: t('Edit information content'),
      status: newStep - 0 === 2 ? 'processing' : 'toDo',
      stepCount: 2,
    },
  ];

  return (
    <>
      <HeaderCreateNewsComponent
        bntTitle={
          <Button
            className="b-danger"
            disabled={loading || !isCanSubmit}
            type="primary"
            onClick={() => {
              if (!newStep || newStep - 0 === 1) {
                if (id) {
                  handleUpdateNext();
                } else {
                  handleSubmitNext();
                }
              } else {
                handleUpdate();
              }
            }}
            style={{
              fontSize: '16px',
              backgroundColor: '#E50A47',
              border: '1px solid #e72158',
              color: '#FFFFFF',
              opacity: loading || !isCanSubmit ? '0.4' : '',
            }}
            danger
          >
            {newStep - 0 === steps.length ? t('SubmitNews') : t('Next step')}
          </Button>
        }
        isHide="view"
        newStep={newStep}
        setps={steps}
        onClick={() => {
          navigate(newStep - 1 ? `/products-knowledge/upload/${newStep - 1}?productKnowledgeId=${id}` : `/products-knowledge`);
        }}
        backTitle={t('Create Product Knowledge')}
      >
        <Spin spinning={loading}>
          {!newStep || newStep - 0 === 1 ? (
            <div className="container newDetail">
              <Row className="mb-5">
                <Col md={4}>{t('Cover')} :</Col>
                <Col md={20}>
                  <Row className="w-100">
                    <Col md={24} sm={24}>
                      <div className="w-100">
                        <OSSUploadWrapper
                          onUploadSuccess={(value) => {
                            setpicUrl([value]);
                          }}
                        >
                          <DragUploadComponent
                            fileList={picUrl ? picUrl : []}
                            setFileList={(values) => {
                              setpicUrl(values);
                            }}
                          />
                        </OSSUploadWrapper>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="mt-4 d-flex align-items-center">
                <Col md={4}>{t('News Title')} :</Col>
                <Col md={20}>
                  <InputComponent
                    className="mb-2"
                    status={isSubmit && !dataObject.title && 'error'}
                    value={dataObject.title}
                    setValue={(value) => setDataObject({ ...dataObject, title: value })}
                    placeholder=""
                  />
                </Col>
              </Row>
              <Row className="mt-4 d-flex align-items-center">
                <Col md={4}>{t('Description')} :</Col>
                <Col md={20}>
                  <InputComponent
                    className="mb-2"
                    status={isSubmit && !dataObject.subtitle && 'error'}
                    value={dataObject.subtitle}
                    setValue={(value) => setDataObject({ ...dataObject, subtitle: value })}
                    placeholder=""
                  />
                </Col>
              </Row>
              <Row className="mt-4 d-flex align-items-center">
                <Col md={4}>{t('Read Time')} :</Col>
                <Col md={20}>
                  <InputNumberComponent
                    min={0}
                    className="mb-2"
                    status={isSubmit && !dataObject.readingTime && 'error'}
                    value={dataObject.readingTime}
                    setValue={(value) => setDataObject({ ...dataObject, readingTime: value })}
                    placeholder=""
                  />
                </Col>
              </Row>
              {/* <Row className="mt-4 d-flex align-items-center">
                <Col md={4}>{t('Category')} :</Col>
                <Col md={20}>
                  <SelectComponent
                    options={optionsCategoryData}
                    value={dataObject.category}
                    setValue={(value, values) => {
                      setDataObject({
                        ...dataObject,
                        categoryId: values?._id,
                        category: values?.name,
                      });
                    }}
                    status={isSubmit && !dataObject.category && 'error'}
                    placeholder=""
                  />
                </Col>
              </Row> */}
            </div>
          ) : (
            <div className="w-100 h-100" style={{ background: 'rgb(241 241 241)' }}>
              <TechnicalDragViewMobileComponent
                ref={dragViewMobileComponentRef}
                datalocalize={datalocalize}
                setDatalocalize={setDatalocalize}
                loading={loading}
                setLoading={setLoading}
                apiUrl={PRODUCTS_KNOWLEDGE_URL}
                redirectUrl="/products-knowledge"
                isProductKnowledge={true}
              />
            </div>
          )}
          <MessageConfirmModal textCentered ref={messageModalRef} />
        </Spin>
      </HeaderCreateNewsComponent>
    </>
  );
}

export default ProductKnowledgeUpload;
